module.exports = __webpack_public_path__ + "img/img_不可用紅包bg@2x.4fdc6f36.png";